import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propStr } from '../../../../helpers/custom-prop-types';
const MyFavoriteSlideTabSwitch = (props) => {
    const { onClick, showMode } = props;
    return (_jsx("div", Object.assign({ className: 'favorite-slide-tab-switch' }, { children: _jsxs("ul", { children: [_jsx("li", { children: _jsx("button", Object.assign({ className: showMode === 'clip' ? 'is-active' : '', onClick: onClick, type: 'button', value: 'clip' }, { children: "\u30AF\u30EA\u30C3\u30D7" })) }), _jsx("li", { children: _jsx("button", Object.assign({ className: showMode === 'board' ? 'is-active' : '', onClick: onClick, type: 'button', value: 'board' }, { children: "\u30DC\u30FC\u30C9" })) })] }) })));
};
MyFavoriteSlideTabSwitch.propTypes = {
    onClick: propFunc().isRequired,
    showMode: propStr().isRequired,
};
export default MyFavoriteSlideTabSwitch;
